import { DiscountType } from "../models/discount";

/** Resolve how many times a coupon has been used from API field variants. */
export function getDiscountUsedCount(
  record: DiscountType & Record<string, unknown>,
): number {
  const nestedUsage = record.usage;
  if (nestedUsage && typeof nestedUsage === "object") {
    const nested = nestedUsage as Record<string, unknown>;
    const nestedCount = nested.count ?? nested.usage_count ?? nested.used;
    if (nestedCount !== null && nestedCount !== undefined && nestedCount !== "") {
      const parsed = Number(nestedCount);
      if (!Number.isNaN(parsed)) return parsed;
    }
  }

  const candidates = [
    record.usage_count,
    record.used,
    record.used_count,
    record.times_used,
    record.redemption_count,
    record.redemptions_count,
    record.discount_usage_count,
    record.usages_count,
  ];

  for (const value of candidates) {
    if (value === null || value === undefined || value === "") continue;
    const parsed = Number(value);
    if (!Number.isNaN(parsed)) return parsed;
  }

  return 0;
}

export function formatDiscountUsageLimit(
  record: DiscountType & Record<string, unknown>,
): string {
  const limit = record.usage_limit;

  if (limit === null || limit === undefined || Number(limit) === 0) {
    return "Unlimited";
  }

  return String(limit);
}
